export function preserveFreezeState(originObj: any, newObj: any) {
  const isFrozen = Object.isFrozen(originObj)

  if (isFrozen && !Object.isFrozen(newObj)) {
    Object.freeze(newObj)
  }

  return newObj
}
